
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 16a8 8 0 118-8 8 8 0 01-8 8zm0-15a7 7 0 107 7 7 7 0 00-7-7z"}}),_c('path',{attrs:{"d":"M6.5 24a.5.5 0 01-.29-.1.5.5 0 01-.2-.47l1.33-9a.5.5 0 01.99.15l-1.19 8 4.62-2.48a.5.5 0 01.48 0l4.62 2.49-1.19-8.02a.5.5 0 011-.14l1.32 9a.5.5 0 01-.73.51L12 21.11l-5.26 2.83a.5.5 0 01-.24.06z"}})])
          )
        }
      }
    